// extracted by css-extract-rspack-plugin
export default {"logoEditContainer":"logo-edit-container--S7oVBLg2tgM83AL4","logoEditInput":"logo-edit-input--KKsRmwqdncXgZOBJ","avatarMask":"avatar-mask--SYgNo9KsG7UR0Q6R"};